module.exports = __webpack_public_path__ + "img/paper-import.cd43d028.png";